import { v4 as uuidv4 } from "uuid";
const countryCodeArray = [
  {
    name: "India",
    code: "91",
    image: "assets/images/flag_india.png",
    id: "IN",
    maxLength: 10,
    currency: "INR",
    razorPayCode: "pl_I1fQb5uX9N2hap",
    price: 2900,
  },
  {
    name: "UAE",
    code: "971",
    image: "assets/images/flag_uae.png",
    id: "AE",
    maxLength: 9,
    currency: "AED",
    razorPayCode: "pl_GiHadsPjreNhnr",
    price: 220,
  },
  {
    name: "USA",
    code: "1",
    image: "assets/images/flag_usa.png",
    id: "US",
    maxLength: 10,
    currency: "USD",
    razorPayCode: "pl_GiHYVHEagksV6L",
    price: 89,
  },
  {
    name: "UK",
    code: "44",
    image: "assets/images/flag_uk.png",
    id: "GB",
    maxLength: 10,
    currency: "GBP",
    razorPayCode: "pl_GiHccdkuQaRfWT",
    price: 89,
  },
  {
    name: "Canada",
    code: "1",
    image: "assets/images/flag_canada.png",
    id: "CA",
    maxLength: 10,
    currency: "CAD",
    razorPayCode: "pl_GiHbQyx1lAfXux",
    price: 89,
  },
  {
    name: "Australia",
    code: "61",
    image: "assets/images/flag_australia.png",
    id: "AU",
    maxLength: 9,
    currency: "AUD",
    razorPayCode: "pl_GiHZS5YwJWaxD6",
    price: 89,
  },
];

export async function getIP(data) {
  if (typeof window !== "undefined" && localStorage.getItem(data) == null) {
    let response = await fetch("https://www.cloudflare.com/cdn-cgi/trace", {
      mode: "cors",
    });
    let text = await response.text();
    localStorage.setItem(
      "country",
      text
        .split("\n")
        .filter((el) => el.startsWith("loc"))
        .join("\n")
        .slice(4)
    );
    //Location - AE- United Arab Emirates, AU- Australia, GB- United Kingdom, IN- India, CA- Canada, US- United States

    localStorage.setItem(
      "ip",
      text
        .split("\n")
        .filter((el) => el.startsWith("ip"))
        .join("\n")
        .slice(3)
    );
  }
  return returnData(data);
}

export default function postLandingPage(landingPageId, url) {
  getIP("ip").then((data) => {
    let urlParams = new URLSearchParams(url);
    let ipAddress = data;
    let userID =
      typeof window !== "undefined" ? localStorage.getItem("userID") : null;
    if (!userID) {
      userID = uuidv4();
      typeof window !== "undefined" && localStorage.setItem("userID", userID);
    }
    fetch("https://services.prod.zyla.in/api/v1/analytics/landingPage", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        utmParam1: urlParams.get("utm1"),
        utmParam2: urlParams.get("utm2"),
        utmParam3: urlParams.get("utm3"),
        ip: ipAddress,
        uuid: userID,
        landingPageId: landingPageId,
      }),
    });
  });
}

function returnData(data) {
  if (typeof window !== "undefined" && data == "ip") {
    return localStorage.getItem("ip");
  } else if (typeof window !== "undefined" && data == "loc") {
    return countryCodeArray.find(
      (country) => localStorage.getItem("country") === country.id
    );
  }
}
